import React from 'react';

export default {
    fields: [
        {
            type: 'text',
            name: 'email',
            props: {
                label: <p><i className="asterisk icon inline"/>Your email</p>,
                helpContent: '',
                helpHeader: '',
                required: true,
                validationRules: [
                    {
                        type: 'EmailFormat'
                    }
                ]
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/pages/Login/forgotPasswordFormConfig.js